<button fastsearchSelect type="button" class="btn btn-light btn-block btn-sm" (click)="select(data)">
  <h4>{{ data.id }} - {{ data.name }}</h4>
</button>
